import React from 'react'
import Navbar from './Navbar/Navbar'
import Section1 from './Section1/Section1'
import Section2 from './Section2/Section2'
import Section3 from './Section3/Section3'
import Section4 from './Section4/Section4'
import Section5 from './Section5/Section5'
import Section6 from './Section6/Section6'
import Section7 from './Section7/Section7'
const SectionMain = () => {
  return (
    <>
    <Navbar />
    {/* Sections with IDs for smooth scroll */}
    <section id="features">{<Section1/>}</section>
    <section id="how-it-works">{<Section2/>}</section>
    <section id="benefits">{<Section3/>}</section>
    <section id="demo">{<Section4/>}</section>
    <section id="contact" >{<Section5/>}</section>
    <section id="contact" >{<Section6/>}</section>
    <section id="contact" >{<Section7/>}</section>
  </>
  )
}

export default SectionMain